import { Card, Typography } from 'antd';

type CardButtonProps = {
  onClick?: () => void;
  id: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  icon: React.JSXElementConstructor<object>;
};

const CardButton = ({ onClick, id, icon: Icon, title, description }: CardButtonProps) => {
  return (
    <Card size='small' className='hover:border-primary cursor-pointer' onClick={onClick} id={id}>
      <Card.Meta
        avatar={<Icon />}
        title={
          <Typography.Title level={5} className='mb-0'>
            {title}
          </Typography.Title>
        }
        description={description ? <span className='text-content-body'>{description}</span> : undefined}
      />
    </Card>
  );
};

export default CardButton;
